import { Power } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { tripsApi } from "../../../api";
import Carousel from "../../../components/Carousel";
import FormCard from "../../../components/FormCard";
import PillButton from "../../../components/PillButton";
import { APIContext } from "../../../connector";
import balanceIcon from "../../../static/images/balanceIcon.svg";
import backgroundCurveImg from "../../../static/images/curve.svg";
import earningIcon from "../../../static/images/monthly_earning.svg";
import totalOrdersIcon from "../../../static/images/totalOrder.svg";
import classes from "./DriverCheckIn.module.scss";

const DriverCheckIn = () => {
  const { userData } = useContext(APIContext);
  const navigate = useNavigate();
  const CREDITS_URL = "https://docs.google.com/forms/d/e/1FAIpQLSccG6Ws7pza-1_a7HrheVpNVACcLfYkkCC27r1YaxI5Y-PhsA/viewform?pli=1";

  var data = {
    name: userData?.name || "Unknown",
    rides: userData?.driver_info?.number_of_trips || 0,
    credit: userData?.driver_info?.credit_balance || 0,
  };

  const [tripCount, setTripCount] = useState(0);
  const [monthlyEarnings, setMonthlyEarnings] = useState(0);
  const [dailyEarnings, setDailyEarnings] = useState(0);

  useEffect(() => {
    const fetchCount = async () => {
      const count = await tripsApi.getCountToday();
      setTripCount(count);
    };

    fetchCount();
  }, []);

  useEffect(() => {
    const fetchDailyEarnings = async () => {
      const earnings = await tripsApi.getEarningsToday(true); 
      setDailyEarnings(earnings);
    };
    fetchDailyEarnings();
  }, []);

  useEffect(() => {
    const fetchEarnings = async () => {
      const earnings = await tripsApi.getEarningsMonth(true);
      setMonthlyEarnings(earnings);
    };

    fetchEarnings();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.backgroundCurve}>
        <img src={backgroundCurveImg} alt="curve" />
      </div>
      {/* 1. top content*/}
      <div className={classes.header}>
        <div className={classes.greetingText}>
          <span className={classes.smallGreeting}>Hey,</span>
          <h2 className={classes.userName}>{data.name?.toUpperCase()}</h2>
        </div>
      </div>

      <div className={classes.carouselContainer}>
        <Carousel />
      </div>

      <div className={classes.innerCardContent}>

        <div className={classes.topCardsRow}>
          <FormCard className={classes.formCard}>
            <div className={classes.cardDetails}>
              <p className={classes.cardTitle}>Credit Balance</p>
              <p className={classes.cardValue}>{data.credit}</p>
              {data.credit <= 0 && <p className={classes.error}>Not Enough Credits</p>}
            </div>
            <div className={`${classes.cardImage} ${classes.creditsLink}`} onClick={() => window.open(CREDITS_URL, "_blank")}>
              <img src={balanceIcon} />
            </div>
          </FormCard>

          <FormCard className={classes.formCard}>
            <div className={classes.cardDetails}>
              <p className={classes.cardTitle}>Total Orders Today</p>
              <p className={classes.cardValue}>{tripCount}</p>
            </div>
            <div className={classes.cardImage}>
              <img src={totalOrdersIcon} width={50} height={50} />
            </div>
          </FormCard>
        </div>

        {/* <FormCard className={classes.formCard}>
          <div className={classes.cardDetails}>
            <p className={classes.cardTitle}>Monthly Earning</p>
            <p className={classes.cardValueMonthly}>RM {monthlyEarnings}</p>
          </div>
          <div className={classes.cardImage}>
            <img src={earningIcon} />
          </div>
        </FormCard> */}

          <div className={classes.topCardsRow}>
          <FormCard className={classes.formCard}>
            <div className={classes.cardDetails}>
              <p className={classes.cardTitle}>Daily Earning</p>
              <p className={classes.cardValue}>RM {dailyEarnings}</p>
            </div>
            <div className={classes.cardImage}>
              <img src={earningIcon} width={40} height={40} />
            </div>
          </FormCard>

          <FormCard className={classes.formCard}>
            <div className={classes.cardDetails}>
              <p className={classes.cardTitle}>Monthly Earning</p>
              <p className={classes.cardValue}>RM {monthlyEarnings}</p>
            </div>
            <div className={classes.cardImage}>
              <img src={earningIcon} width={40} height={40} />
            </div>
          </FormCard>
        </div>

        <PillButton
          onClick={() => navigate("/driver-orders")}
          className={`acceptButton ${classes.checkInButton}`}
          disabled={data.credit <= 0}
        >
          <Power size={18} className={classes.Icon} /> Go Online
        </PillButton>
      </div>
    </div>
  );
};

export default DriverCheckIn;
